import type { GameState, Move, MoveResult } from "../types";
import { applyEndTurn } from "./endTurn";
import { checkVictory } from "./helpers";
import { executeNonTurnMove } from "./runners";
import { validateMove } from "./validate";

export { checkVictory } from "./helpers";

export function applyMove(state: GameState, move: Move): MoveResult {
  validateMove(state, move);
  if (move.type === "endTurn") return applyEndTurn(state);
  const step = executeNonTurnMove(state, move);
  const next = {
    ...step.state,
    status: checkVictory(step.state),
  };
  return { state: next, events: step.events };
}
